@if (avatarService.loggedInAvatarUrl$ | async; as avatarImageUrl) {
    <img
        referrerpolicy="no-referrer"
        [attr.src]="avatarImageUrl"
        class="avatar"
        [class.small]="size === 'small'"
        [class.large]="size === 'large'"
        [class.cursor-pointer]="button"
        [class.cursor-default]="!button"
        alt="Avatar"
    />
} @else {
    <div
        class="avatar default-avatar"
        [class.small]="size === 'small'"
        [class.large]="size === 'large'"
        [class.cursor-pointer]="button"
        [class.cursor-default]="!button"
    >
        {{ avatarService.avatarInitials$ | async }}
    </div>
}
